import Crud from '../components/Research/Crud'
import Research from '../components/Research/Research'
import ControlPanel from '../components/Research/ControlPanel'

let routes = {
    path: '/researches',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/researches',
          name: 'Pesquisas',
          component: Crud
      },
      {
          path: '/research/:id?',
          name: 'Pesquisa',
          component: Research
      },
      {
        path: '/controlPanel/:id?',
        name: 'Painel de Controle',
        component: ControlPanel
    },
    ],
}

export default routes


// WEBPACK FOOTER //
// ./src/router/research.js